var menuMfn = {}
menuMfn.init = function(){
	var menu = document.querySelector('#menu');
	var menuM = document.querySelector('#menu_m');
	var body = document.body;
	menuM.addEventListener('click', function(){
		var transClass = this.className; 
		if(transClass.search('active') >= 0){
			this.classList.remove('active');
			body.classList.remove('lock');
			menu.classList.remove('active');
		}else{
			this.classList.add('active');
			body.setAttribute('class', 'lock');
			menu.classList.add('active');
		}
	})
}
export default menuMfn;